export const modal = { // Modulo notifiche
  namespaced: true,
  state: {
    modal: {}
  },
  actions: {
    showModal ({ commit }, modal) {
      modal.showing = true
      commit('setModal', modal)
    }
  },
  mutations: {
    setModal (state, modal) {
      state.modal = modal
    }
  }
}
